module.exports = __webpack_public_path__ + "./Dennis_3d3ff54a952a6ccd6b10d867db43ab8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Dennis.jpg
// module id = 524
// module chunks = 0